import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { ErrorMessageComponent } from '../error-message/error-message.component';
import { MVMSpinnerBtnModule } from '../../../../shared/mvm-components/mvm-spinner-btn/mvm-spinner-btn.module';
import { NmvtisShellModalComponent } from './nmvtis-shell-modal.component';
import { PsvrComponent } from '../psvr/psvr.component';
import { SharedPipesModule } from '../../../../shared/pipes/shared-pipes.module';
import { SharedValidatorsModule } from '../../../../shared/validators/shared-validators.module';
import { ValidationResultsModule } from '../../../../shared/components/validation-results/validation-results.module';
import { VehicleBrandsMessageComponent } from '../vehicle-brands-message/vehicle-brands-message.component';
import { VehicleMatchedComponent } from '../vehicle-matched/vehicle-matched.component';
import { VehicleNotFoundComponent } from '../vehicle-not-found/vehicle-not-found.component';
import { VehicleSelectionComponent } from '../vehicle-selection/vehicle-selection.component';
import { MessageService } from 'primeng/api';
import { OdometerReadingLowComponent } from '../odometer-reading-low/odometer-reading-low.component';

@NgModule({
    declarations: [
        ErrorMessageComponent,
        NmvtisShellModalComponent,
        PsvrComponent,
        VehicleBrandsMessageComponent,
        VehicleMatchedComponent,
        VehicleNotFoundComponent,
        VehicleSelectionComponent,
        OdometerReadingLowComponent
    ],
    providers: [
        MessageService
    ],
    imports: [
        CommonModule,
        FormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        ReactiveFormsModule,
        MVMSpinnerBtnModule,
        SharedPipesModule,
        SharedValidatorsModule,
        ValidationResultsModule,
        ToastModule
    ],
    exports: [
        ErrorMessageComponent,
        NmvtisShellModalComponent,
        VehicleBrandsMessageComponent,
        VehicleMatchedComponent,
        VehicleNotFoundComponent,
        VehicleSelectionComponent,
        OdometerReadingLowComponent
    ]
})
export class NmvtisShellModule {
}
